module.exports = __webpack_public_path__ + "img/machine-report.6f5ed6e6.svg";